module.exports = __webpack_public_path__ + "img/switch.bc0975f6.svg";